module.exports = __webpack_public_path__ + "static/media/whichThinnerDontMiss.9a73f62f.mp3";